import { isReactive, reactive } from 'vue'
import type { GridOption } from '../grid-option'
import { isGridOption } from './is-grid-option'
import type { GridOptions } from '../types'

export function resolveGridOptions(input: GridOption | GridOptions): GridOptions {
  if (isReactive(input)) {
    return input as GridOptions
  }
  return reactive(input as GridOptions)
}

export function isSameGridOptionsReference(
  a: GridOption | GridOptions,
  b: GridOptions
) {
  return a === b || (isGridOption(a) && isGridOption(b) && a === b)
}
